// import type { PsHttpSSE } from '@patsnap-utils/sse';

import type {
  ChatInput,
  ChatResponse,
} from '@/components/pages/reverse-engineering/types/message.types';

import type {
  SearchResultRequest,
  SearchResultResponse,
} from '@/components/pages/reverse-engineering/types/search.types';

import type { PsHttpSSE } from '@patsnap-utils/sse';

export const ReverseEngineeringApi = Symbol('ReverseEngineeringApi');

export interface ReverseEngineeringApi {
  chat(input: ChatInput): Promise<ChatResponse>;
  connect(conversation_id: string): PsHttpSSE<Record<any, any>>;
  getSearchResult(input: SearchResultRequest): Promise<SearchResultResponse>;
  getProcesses(input: Record<any, any>): Promise<Record<any, any>>;
}
